import { Dialog } from "vant";

let webSocket = null;
let isConnect = false; //连接状态
let retryCount = 0; //重连次数
let maxRetryCount = 30; //最大重连次数
let clearsetTimeout = null;
//定义外部接收数据的成功回调函数
let globalCallback = function(e) {
  // console.log(e);
};
//心跳设置
let heartCheck = {
  heartbeatData: {
    type: "PING",
  }, //心跳包
  timeout: 3 * 1000, //每段时间发送一次心跳包 这里设置为60s
  heartbeat: null, //延时发送消息对象（启动心跳新建这个对象，收到消息后重置对象）
  start: function() {
    this.heartbeat = setInterval(() => {
      if (isConnect) {
        webSocketSend(this.heartbeatData);
      } else {
        this.clear();
      }
    }, this.timeout);
  },
  reset: function() {
    clearInterval(this.heartbeat);
    this.start();
  },
  clear: function() {
    clearInterval(this.heartbeat);
  },
};

/**
 * 重连
 */
function reconnect(e) {
  if (retryCount < maxRetryCount) {
    initWebSocket();
    retryCount++;
  } else {
    clearTimeout(clearsetTimeout);
    Dialog({
      confirmButtonText: "OK",
      message: "Please check the network and refresh to try again!",
    });
  }
}

//初始化websocket
function initWebSocket(callback) {
  //此callback为在其他地方调用时定义的接收socket数据的函数
  if (callback) {
    if (typeof callback == "function") {
      globalCallback = callback;
    } else {
      throw new Error("callback is not a function");
    }
  }
  if ("WebSocket" in window) {
    const userId = localStorage.getItem("userId");
    const websocketUrl = `wss://ws.almurl.work/websockets/users/${userId}`;
    // const websocketUrl = `wss://ws.almtest.work/websockets/users/${userId}`;
    webSocket = new WebSocket(websocketUrl); //创建socket对象
  } else {
    Dialog({
      message: "Websocket not support",
    });
    return;
  }
  //打开
  webSocket.onopen = function() {
    webSocketOpen();
  };
  //收信
  webSocket.onmessage = function(e) {
    webSocketOnMessage(e);
  };
  //关闭
  webSocket.onclose = function(e) {
    webSocketOnClose(e);
  };
  //连接发生错误的回调方法
  webSocket.onerror = function(e) {
    webSocketOnError(e);
  };
}

//连接socket建立时触发
function webSocketOpen() {
  retryCount = 0;
  isConnect = true;
  webSocketSend(heartCheck.heartbeatData);
  heartCheck.clear();
  heartCheck.start();
}

//客户端接收服务端数据时触发,e为接受的数据对象
function webSocketOnMessage(e) {
  const data = JSON.parse(e.data); //根据自己的需要对接收到的数据进行格式化
  globalCallback(data);
}

//socket关闭时触发
function webSocketOnClose(e) {
  heartCheck.clear();
  isConnect = false;
  if (e.code == 1006) {
    clearsetTimeout = setTimeout(() => {
      reconnect(e);
    }, 1000);
  }
  if (e.code == 1000) {
    clearTimeout(clearsetTimeout);
  }
}

//连接发生错误的回调方法
function webSocketOnError(e) {
  heartCheck.clear();
  isConnect = false; //断开后修改标识
}

//发送数据
function webSocketSend(data) {
  webSocket.send(JSON.stringify(data)); //在这里根据自己的需要转换数据格式
}

//在其他需要socket地方主动关闭socket
function closeWebSocket(isRetry) {
  webSocket.close();
  heartCheck.clear();
  isConnect = false;
  retryCount = 0;
}

//在其他需要socket地方接受数据
function getSock(callback) {
  globalCallback = callback;
}

//在其他需要socket地方调用的函数，用来发送数据及接受数据
function sendSock(agentData) {
  //下面的判断主要是考虑到socket连接可能中断或者其他的因素，可以重新发送此条消息。
  switch (webSocket.readyState) {
    //CONNECTING：值为0，表示正在连接。
    case webSocket.CONNECTING:
      setTimeout(function() {
        sendSock(agentData, callback);
      }, 1000);
      break;
    //OPEN：值为1，表示连接成功，可以通信了。
    case webSocket.OPEN:
      webSocketSend(agentData);
      break;
    //CLOSING：值为2，表示连接正在关闭。
    case webSocket.CLOSING:
      setTimeout(function() {
        sendSock(agentData, callback);
      }, 1000);
      break;
    //CLOSED：值为3，表示连接已经关闭，或者打开连接失败。
    case webSocket.CLOSED:
      // do something
      sendSock(callback);
      break;
    default:
      // this never happens
      break;
  }
}

export default {
  initWebSocket,
  closeWebSocket,
  sendSock,
  getSock,
};
